export default __webpack_public_path__ + "static/media/MusicalIntruments_15.d14a015a.png";